import { render, staticRenderFns } from "./SetLanguage.vue?vue&type=template&id=056ab492&scoped=true&"
import script from "./SetLanguage.vue?vue&type=script&lang=js&"
export * from "./SetLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056ab492",
  null
  
)

export default component.exports